import React, { useMemo } from "react";
import { Link } from "react-router";
import Utility from "../../../utils/DateParser";

import Table from "../../common/tables/ActionTable";
import {
  ViewButton,
  EditButton,
  GridActionButton,
} from "../../common/inputs";
import { GridActionContainer } from "../../common/containers/formContainer";

function TeamMembersTable({
  tableRef,
  service,
  searchKeyword,
  owner,
  country,
  additionalFilter,
  category,
  countryId,
  onSelectRow,
  selectedRows,
  entityId,
  constants,
  onEdit,
  onSettings,
  onOpenNewsletterModal,
  onOpenManagingContactModal,
  onDelete,
  onSyncToHubspot,
  onBulkSyncToHubspot,
}) {
  const { ParseDateDMY } = Utility();

  const formatSettingsPayload = (data) => {
    return {
      ...data,
      send_newsletter:
        data.receiveEmailNotification === true ||
        data.receiveEmailNotification === "1"
          ? true
          : false,

      enable_newsletter_subscription:
        data.enableNewsletter === true ||
        data.enable_newsletter_subscription === "1"
          ? true
          : false,

      managing_bp_contact:
        data.managingFifoContact || data.managing_bp_contact || null,
    };
  };

  const canManageContact = (row) =>
    row.owner === entityId ||
    category === constants.CATEGORY.COUNTRY_OFFICE ||
    category === constants.CATEGORY.INTL_OFFICE;

  const ActionPanel = () =>
    Array.isArray(selectedRows) &&
    selectedRows.some((obj) => obj.checked) && (
      <GridActionContainer>
        <GridActionButton
          label="Change Managing Contact"
          handleClick={onOpenManagingContactModal}
          class="btn btn-sm btn-outline-secondary mr-2"
        />

        <GridActionButton
          label="Change Newsletter Subscription"
          handleClick={onOpenNewsletterModal}
          class="btn btn-sm btn-outline-secondary mr-2"
        />

        {(category === constants.CATEGORY.COUNTRY_OFFICE ||
          category === constants.CATEGORY.INTL_OFFICE) && (
          <GridActionButton
            label="Sync to HubSpot"
            handleClick={onBulkSyncToHubspot}
            class="btn btn-sm btn-outline-secondary mr-2"
          />
        )}
      </GridActionContainer>
    );

   

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: "Organization",
        accessor: "organization",
        headerStyle: { textAlign: "left" },
        Cell: (row) => (
          <Link
            className="link"
            to={{
              pathname:
                row.original.account_type === "secondary"
                  ? "/seconadry-account/details/home"
                  : "/entities/details/home",
              search: `?a_guid=${row.original.a_guid}`,
            }}
          >
            {row.original.organization}
          </Link>
        ),
      },
      {
        Header: "First Name",
        accessor: "first_name",
        headerStyle: { textAlign: "left" },
        Cell: (row) => <span>{row.original.first_name}</span>,
      },
      {
        Header: "Last Name",
        accessor: "last_name",
        headerStyle: { textAlign: "left" },
        Cell: (row) => <span>{row.original.last_name}</span>,
      },
      {
        Header: "Email",
        accessor: "email",
        headerStyle: { textAlign: "left" },
        minWidth: 120,
        Cell: (row) => <span>{row.original.email}</span>,
      },
      {
        Header: "Phone No",
        accessor: "phone_no",
        minWidth: 60,
        headerStyle: { textAlign: "left" },
      },
      {
        Header: "Managed By",
        accessor: "managing_contact_name",
        headerStyle: { textAlign: "left" },
      },
      {
        Header: "Marketing",
        accessor: "enable_newsletter_subscription",
        headerStyle: { textAlign: "left" },
        Cell: (row) => (
          <span>
            {row.original.enable_newsletter_subscription === "1"
              ? "Subscribed"
              : "Not Subscribed"}
          </span>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        headerStyle: { textAlign: "left" },
        Cell: (row) => {
          const status = row.original.status;
          const formattedStatus = status
            ? status.charAt(0).toUpperCase() + status.slice(1)
            : "";

          return (
            <span
              className={
                formattedStatus === "Active" ? "text-success" : "text-danger"
              }
            >
              {formattedStatus}
            </span>
          );
        },
      },
      {
        Header: "Created At",
        accessor: "created_at",
        headerStyle: { textAlign: "left" },
        Cell: (row) => <>{ParseDateDMY(row.original?.created_at)}</>,
      },
    ];

    if (
      category === constants.CATEGORY.COUNTRY_OFFICE ||
      category === constants.CATEGORY.INTL_OFFICE
    ) {
      baseColumns.push({
        Header: "HS Sync Status",
        accessor: "crm_sync_status",
        headerStyle: { textAlign: "left" },
        minWidth: 70,
        Cell: (row) => {
          const isSynced = row.original.crm_sync_status === "yes";

          return (
            <span
              className={isSynced ? "text-success" : "text-danger"}
              title={
                row.original.crm_sync_date
                  ? `Last Sync: ${ParseDateDMY(row.original.crm_sync_date)}`
                  : "No sync date"
              }
            >
              {isSynced ? "Yes" : "No"}
            </span>
          );
        },
      });
    }

    baseColumns.push({
      Header: "Action",
      accessor: "action",
      headerStyle: { textAlign: "right" },
      minWidth: 80,
      Cell: (row) => (
        <div className="pull-right">
          <Link
            className="action-icons"
            style={{ color: "grey" }}
            to={{
              pathname:
                row.original.account_type === "secondary"
                  ? "/seconadry-account/details/home"
                  : "/entities/details/home",
              search: `?a_guid=${row.original.a_guid}`,
            }}
          >
            <ViewButton />
          </Link>

          {canManageContact(row.original) && (
            <>
              <button
                type="button"
                className="action-icons btn btn-link p-0 ml-2 pull-right"
                data-toggle="dropdown"
              >
                <i className="fa fa-ellipsis-v"></i>
              </button>

              <div className="dropdown-menu">
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => onSettings(formatSettingsPayload(row.original))}
                >
                  Settings
                </button>

               {row.original.account_type === "primary" && (
                <Link
                  type="button"
                  className="dropdown-item"
                  to={{
                    pathname: "/entities/details/profile",
                    search: `?a_guid=${row.original.a_guid}`,
                  }}
                >
                  Entity Profile
                </Link>
               )}
                
              {row.original.account_type === "primary" && (
                <Link
                  type="button"
                  className="dropdown-item"
                  to={{
                    pathname: "/entities/details/documents",
                    search: `?a_guid=${row.original.a_guid}`,
                  }}
                >
                  Documents
                </Link>
              )}

                {(category === constants.CATEGORY.COUNTRY_OFFICE ||
                  category === constants.CATEGORY.INTL_OFFICE) && (
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => onSyncToHubspot(row.original)}
                  >
                    Sync to HubSpot
                  </button>
                )}

                <hr />

                <button
                  type="button"
                  className="dropdown-item text-danger"
                  onClick={() => onDelete(row.original.contact_id)}
                >
                  Delete
                </button>
              </div>

              <button
                type="button"
                className="action-icons btn btn-link p-0"
                onClick={() => onEdit(row.original)}
              >
                <EditButton />
              </button>
            </>
          )}
        </div>
      ),
    });

    return baseColumns;
  }, [entityId, category, constants]);

  return (
    <Table
      ref={tableRef}
      service={service}
      cols={columns}
      uid="contact_id"
      tableLeftPanel={null}
      reqParams={{
        searchKeyword,
        country:
          category === constants.CATEGORY.COUNTRY_OFFICE ? countryId : country,
        bp: owner === "all" ? null : owner,
        ...additionalFilter,
      }}
      onSelectRow={onSelectRow}
      actionPanel={<ActionPanel />}
    />
  );
}

export default TeamMembersTable;